$(document).ready(async function () {
	window.isLoading = false;
	window.limit = 24;

	$(document).on("click", ".file-icon", async function () {
		window.productBlock = $(this).parents(".product-block");
		const productType = $(this).attr("data-product-type");
		const handle = $(this).attr("data-handle");
		const title = $(this).attr("data-product-title");
		const haveMultiSizes = $(this).attr("data-product-multiple-size");

		$(this)
			.parents("product-block")
			.find(".buy-once")
			.addClass("merge-item-refreshing");

		if (!productType && !handle) {
			return;
		}

		await handleRechargeConfiguration(handle);

		const productUrl = `/pages/featured-product-test/handle=${handle}`;
		const response = await fetch(productUrl);
		const responseText = await response.text();
		const $response = $(responseText);
		const $productForm = $response.find("product-form");
		Hybrid.Drawer.open({
			header: title,
			content: '<div id="customQuickView"></div>',
		});

		$("#customQuickView").append($productForm);

		const displayColor = $(this).attr("data-display-color");

		setTimeout(() => {
			$(`#customQuickView input[value="${displayColor}"]`).next().click();

			const selectedVariant = document.querySelector(
				"#customQuickView variant-picker"
			)?.variant;

			const mediaId = selectedVariant?.featured_media?.id?.toString();

			if (mediaId) {
				$(
					`#customQuickView li[data-media-id="${mediaId}"] img`
				).click();
			}

			const haveAdded = $(this)
				.parents("product-block")
				.find(".buy-once")
				.hasClass("added");
			if (haveAdded) {
				$(".add-to-cart").replaceWith(
					$(this)
						.parents("product-block")
						.find(".buy-once")
						.next()
						.clone(true)
				);

				const selectedVariantId = $(this)
					.parent()
					.find(".remove")
					.attr("data-variant-id");

				// Code for select default variant as added on cart already
				if (selectedVariantId && window.variantData) {
					const selectedVariant = window.variantData.variants.find(
						(item) => item.id == selectedVariantId
					);
					const color = selectedVariant?.option1;
					const size = selectedVariant?.option2;

					if (color) {
						$(`input[value="${color}"]`).next().click();
					}

					if (size) {
						$(`input[value="${size}"]`).next().click();
					}
				}
			}

			$("#customQuickView .quantity-submit-row__submit").css(
				"max-width",
				"448px"
			);
		}, 500);
		handleMemberPricing();
	});

	$(document).on("change", 'input[name="purchaseOption"]', function (e) {
		if ($(this).val() == "onetime") {
			$('input[name="selling_plan"]').val("");
		} else {
			const sellingPlan = $(".rc-selling-plans-dropdown__select").val();
			$('input[name="selling_plan"]').val(sellingPlan);
		}
	});

	$(document).on("change", ".rc-selling-plans-dropdown__select", function () {
		const sellingPlan = $(this).val();
		if ($('input[name="purchaseOption"]').prop("checked")) {
			$('input[name="selling_plan"]').val(sellingPlan);
		}
	});

	// Listen for the custom event
	window.addEventListener("customCartUpdated", function (event) {
		// if (event.detail.newQuantity == 0) {
		//     window.updatedTrigger = false;
		// } else {
		//     window.updatedTrigger = true;
		// }

		// let variantId = false;
		// if (event.detail.newQuantity === 0) {
		//     const variationDetail = Object.keys(event.detail.updates)[0];
		//     // Extract the part before the colon
		//     const extractedKey = variationDetail.split(':')[0];
		//     variantId = extractedKey
		// } else if (event.detail.fromMemberPerks) {
		//     const variationId = e.detail.variantId
		//     variantId = variationId;
		// }

		// if (variantId) {
		//     $(`span[data-variant-id="${extractedKey}"]`).removeClass('added');
		//     $(`span[data-variant-id="${extractedKey}"]`).removeAttr('data-variant-id');
		//     $(`span[data-variant-id="${extractedKey}"]`).prev().removeClass('added')
		// }

		const { newQuantity, updates, fromMemberPerks, variantId } =
			event.detail;

		window.updatedTrigger = newQuantity !== 0;

		let extractedKey = "";
		if (newQuantity === 0) {
			const variationDetail = Object.keys(updates)[0];
			extractedKey = variationDetail.split(":")[0];
		} else if (fromMemberPerks) {
			extractedKey = variantId;
		}

		if (extractedKey) {
			$(`span[data-variant-id="${extractedKey}"]`)
				.removeClass("added")
				.removeAttr("data-variant-id")
				.prev()
				.removeClass("added");
		}

		if (window.cartJson && event?.detail?.cart) {
			window.cartJson = event.detail.cart;
		}
	});

	$(".sticky_cta_row").show();

	$(document).on("click", ".cta-continue-cart", function (e) {
		e.preventDefault();
		document.querySelector(".js-cart-drawer").open();
	});

	window.openCollectionId = $(".customCollection:first").attr(
		"data-collection-id"
	);

	document.addEventListener("custom:filterAjaxComplete", function (e) {
		$(".customCollection").hide();
		$(`#collection-${window.openCollectionId}`).show();
		removePageQueryParamPerks();

		// setTimeout(() => {
		//     hideSwatchWhenItemIsOne();
		// }, 200);
	});

	document.addEventListener("on:carousel-slider:select", function (e) {
		const ul = document.querySelector(".thumbnails ul");
		const itemToActivate = ul.querySelector(".is-active");
		// Scroll the ul to the active item
		// ul.scrollTop = itemToActivate.offsetTop - ul.offsetTop;
		$(ul).animate({
			scrollTop: itemToActivate.offsetTop - ul.offsetTop,
		});
	});

	$(document).on(
		"click",
		".collectionListWrapper .product-link, .buy-once",
		async function (e) {
			e.preventDefault();
			$(this)
				.parents("product-block")
				.find(".buy-once")
				.addClass("merge-item-refreshing");
			const checkIsHaveSingle = $(this).attr("data-product-type");
			const haveAutoShip = $(this).attr("data-has-selling-plan");

			if (checkIsHaveSingle == "single" && haveAutoShip !== "true") {
				const productId = $(this).attr("data-product-id");
				const variationId = $(this).attr("data-single-variant-id");
				await handleSingleItemAddToCart(productId, variationId);
				$(this).removeClass("merge-item-refreshing");
				$(this).addClass("is-success");
				setTimeout(() => {
					$(this).removeClass("is-success");
				}, 2000);

				$(this).addClass("added");
				$(this).next().addClass("added");
				$(this).next().attr("data-variant-id", variationId);
			} else {
				$(this).parents("product-block").find(".file-icon").click();
			}

			handleMemberPricing();
		}
	);

	$(document).on("click", ".remove", async function (e) {
		e.preventDefault();

		$(this).addClass("merge-item-refreshing");
		const variationId = $(this).attr("data-variant-id");

		await handleRemoveItemFromCart(variationId);

		$(this).removeClass("merge-item-refreshing");

		// $(this).removeClass("added");
		// $(this).prev().removeClass("added");

		Hybrid.Drawer.close();

		// if (window.productBlock && window.productBlock.find('.remove').hasClass('added')) {
		//     window.productBlock.find('.remove').removeClass('added')
		//     window.productBlock.find('.buy-once').removeClass('added')
		// }
	});

	document.addEventListener("on:cart:add", function (e) {
		if (window.productBlock) {
			window.productBlock.find(".buy-once").addClass("added");
			window.productBlock.find(".buy-once").next().addClass("added");
			window.productBlock
				.find(".buy-once")
				.next()
				.attr("data-variant-id", e.detail.variantId);
		}
		Hybrid.Drawer.close();
	});

	document.addEventListener("after:open:Hybrid:Drawer", function (e) {
		$(".buy-once.merge-item-refreshing").removeClass(
			"merge-item-refreshing"
		);
		setTimeout(() => {
			hideTuxStatusInActive();
			$("#customQuickView .remove").text("Added");
		}, 200);
	});

	// document.addEventListener('on:variant:change', function (e) {
	//     const variant = e.detail.variant;
	//     if (window.productBlock) {
	//         const displayColor = window.productBlock.find('.file-icon').attr('data-display-color');
	//         const haveAdded = window.productBlock.find('.buy-once').hasClass('added');
	//         if (displayColor && variant.title.includes(displayColor) && haveAdded) {
	//             $('.add-to-cart').replaceWith(window.productBlock.find('.buy-once').next().clone(true));
	//         }
	//     }
	// })

	handleCartAttributesUpdate();
	// hideSwatchWhenItemIsOne();

	// document.addEventListener('customCartUpdated', function (e) {
	//     console.log(e);
	// })

	$(document).on(
		"click",
		".loadmoreCustomButton .pagination__next_custom",
		async function (e) {
			e.preventDefault();
			$(this).addClass("merge-item-refreshing");
			const pageCount = parseInt($(this).attr("data-page-count"));
			const totalProducts = parseInt(
				$(this).attr("data-total-product-count")
			);
			const collectionId = $(this).attr("data-collection-id");
			const totalPages = Math.ceil(totalProducts / 24);

			const pageHandle = $(this).attr("data-collection-handle");
			const $response = await getCollectionProductByHandle(
				pageCount,
				pageHandle
			);
			const productBlocks = $response
				.find(`#collection-${collectionId} .product-grid`)
				.html();
			$(
				`#collection-${collectionId} .product-grid .popupHtmlCustom`
			).remove();
			$(this)
				.parents(`#collection-${collectionId}`)
				.find(".product-grid")
				.append(productBlocks);
			$(this).attr("data-page-count", parseInt(pageCount) + 1);
			$(this).removeClass("merge-item-refreshing");

			hideSingleVariationSwatch();
			if (pageCount >= totalPages) {
				$(this).hide();
			}
		}
	);

	hideSingleVariationSwatch();

	document.addEventListener("on:cart:change", function (e) {
		const fromMemberPerks = e?.detail?.fromMemberPerks;
		if (fromMemberPerks) {
			const variationId = e.detail.variantId;
			const removeButton = $(`span[data-variant-id="${variationId}"]`);

			if (removeButton.length > 0) {
				removeButton.removeAttr("data-variant-id");
				removeButton.removeClass("added");
				removeButton.prev().removeClass("added");
			}
		}
	});

	document.addEventListener("on:cart:after-merge", function (e) {
		console.log("on:cart:after-merge trigger");
		$(".header-account-link").show();
		$(".cart-link").show();
	});

	// if(window.location.href.includes('ab=d1')){
	//    handleABTestUI();
	// }

	// $(document).on('click', '.nav-subscription .nav-item:nth-child(2)' , function (e) {
	//     e.preventDefault();

	// })
});

const handleRechargeConfiguration = async (handle) => {
	try {
		const productPageUrl = `/products/${handle}`;
		const response = await fetch(productPageUrl);
		const responseText = await response.text();

		// Create a DOMParser to parse the response text
		const parser = new DOMParser();
		const doc = parser.parseFromString(responseText, "text/html");
		console.log(doc);
		// Define the target script IDs
		const scriptIds = [
			"SubscriptionWidgetConfig__shopify_settings",
			"SubscriptionWidgetConfig__preview_config",
			"SubscriptionWidgetConfig__configs",
		];

		// Loop through and execute each script from the parsed document
		scriptIds.forEach((id) => {
			const scriptTag = doc.getElementById(id);
			if (scriptTag) {
				const scriptContent = scriptTag.textContent;
				const scriptElement = document.createElement("script");
				scriptElement.textContent = scriptContent;
				document.body.appendChild(scriptElement);
				console.log(
					`Script with id="${id}" from parsed doc executed successfully`
				);
			} else {
				console.log(
					`Script with id="${id}" not found in parsed response`
				);
			}
		});
	} catch (error) {
		console.log("Error fetching or executing script:", error);
	}
};

const handleMemberPricing = () => {
	let attempts = 0; // Initialize counter

	const interval = setInterval(() => {
		const rechargeWidget = document
			.querySelector("#te-modal recharge-subscription-widget")
			?.shadowRoot?.querySelector(".rc-selection__root");
		if (rechargeWidget) {
			const memberPrice = $(".unit-price__price.member-price").attr(
				"data-member-price"
			);
			const originalPrice = $(".unit-price__price.member-price").attr(
				"data-orignal-price"
			);
			if (memberPrice && originalPrice) {
				const priceHtml = `<span class="rc-price strike-through">${originalPrice}</span>
                                <span class="rc-price" style="color:#00c158;font-weight:700">${memberPrice}</span>`;

				// Check if shadow DOM exists
				const shadowRoot = document.querySelector(
					"recharge-subscription-widget"
				).shadowRoot;
				if (shadowRoot) {
					const priceElement = shadowRoot.querySelector(
						".rc-selection__onetime .rc-purchase-option__prices"
					);

					if (priceElement) {
						priceElement.innerHTML = priceHtml;
					} else {
						console.log("Price element not found in shadow DOM");
					}
				} else {
					console.log(
						"Shadow root not found on recharge-subscription-widget"
					);
				}
			} else {
				console.log("Member or original price attribute missing");
			}

			clearInterval(interval); // Stop the interval if the widget is found and prices are updated
		}

		attempts++; // Increment the counter
		if (attempts >= 50) {
			console.log("Reached maximum attempts, clearing interval");
			clearInterval(interval); // Stop the interval if it reaches 50 attempts
		}
	}, 50);
};

const hideSingleVariationSwatch = () => {
	$(".product-block-options__inner").each((index, item) => {
		const items = $(item).find(".product-block-options__item");
		if (items.length === 1) {
			items.hide();
		}
	});
};

const getCollectionProductByHandle = async (pageCount, pageHandle) => {
	const productUrl = `/pages/member-perks/?page=${pageCount}`;
	const response = await fetch(productUrl);
	const responseText = await response.text();

	const $response = $(responseText);

	return $response;
};

const handleCartAttributesUpdate = () => {
	const subscriptionData = JSON.parse(
		localStorage.getItem("subscriptionData")
	);
	const surpriceMe = subscriptionData?.drawer?.surprise_me;

	if (surpriceMe && surpriceMe !== "yes") {
		const selectedItems = getSelectedItemsImageUrl(
			subscriptionData.drawer.underwear.skus
		);
		const selectedItemsStrings = selectedItems.join(",");
		var formData = new FormData();
		formData.append("attributes[_subscriptionData]", selectedItemsStrings);
		fetch(window.Shopify.routes.root + "cart/update.js", {
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => console.log(data));
	} else {
		var formData = new FormData();
		formData.append("attributes[_subscriptionData]", "");
		fetch(window.Shopify.routes.root + "cart/update.js", {
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => console.log(data));
	}
};

const handleRemoveItemFromCart = async (variantId) => {
	const formData = new FormData();

	formData.append("id", variantId);
	formData.append("quantity", 0);

	const response = await fetch(theme.routes.base + "/cart/change.js", {
		method: "POST",
		headers: {
			Accept: "application/javascript",
			"X-Requested-With": "XMLHttpRequest",
		},
		body: formData,
	});

	if (!response.ok) throw new Error(response.status);

	const data = await response.json();

	document.documentElement.dispatchEvent(
		new CustomEvent("on:cart:change", {
			bubbles: true,
			cancelable: false,
			detail: {
				openDrawer: false,
				data,
				variantId,
				fromMemberPerks: true,
			},
		})
	);

	// Dispatch custom event with method and url
	const event = new CustomEvent("customCartUpdated", {
		bubbles: true,
		detail: {
			data,
			variantId,
			fromMemberPerks: true,
		},
	});
	window.dispatchEvent(event);
};

const getSelectedItemsImageUrl = (items) => {
	const selectedImages = [];
	// Iterate through each key in the items object
	for (const key in items) {
		// Check if the key is a direct property of the object and if the 'selected' property is set to 'yes'
		if (items.hasOwnProperty(key) && items[key].selected === "yes") {
			// Add the selected item to the array
			selectedImages.push(items[key].details.image);
		}
	}
	// Return the array of selected items
	return selectedImages;
};

const handleSingleItemAddToCart = async (productId, variantId) => {
	const formData = new FormData();

	formData.append("id", variantId);
	formData.append("form_type", "product");
	formData.append("quantity", 1);
	formData.append("product-id", productId);

	const response = await fetch(theme.routes.cartAdd, {
		method: "POST",
		headers: {
			Accept: "application/javascript",
			"X-Requested-With": "XMLHttpRequest",
		},
		body: formData,
	});

	if (!response.ok) {
		$(".buy-once.merge-item-refreshing").removeClass(
			"merge-item-refreshing"
		);
		throw new Error(response.status);
	}

	const data = await response.json();

	document.documentElement.dispatchEvent(
		new CustomEvent("on:cart:change", {
			bubbles: true,
			cancelable: false,
			detail: { openDrawer: false },
		})
	);

	showNotfication(data);
};

const showNotfication = (data) => {
	if (theme.settings.afterAddToCart === "notification") {
		const notification = document
			.getElementById("AddedNotification")
			.content.firstElementChild.cloneNode(true);
		notification.dataset.productTitle = data.product_title;
		let notificationContainer = document.querySelector(
			".pageheader--sticky"
		);
		if (!notificationContainer) {
			notificationContainer = document.querySelector("body");
		}
		notificationContainer.appendChild(notification);
	}
};

const removePageQueryParamPerks = () => {
	// Get the current URL
	const url = new URL(window.location.href);

	// Get the URLSearchParams object
	const params = url.searchParams;

	// Delete the 'page' query parameter
	params.delete("page");

	// Update the URL without reloading the page
	const newUrl = url.pathname + "?" + params.toString();
	window.history.pushState({}, "", newUrl);
};

const getRemovedVariantIdFromCart = (updates) => {
	for (const variantId in updates) {
		if (updates.hasOwnProperty(variantId) && updates[variantId] === 0) {
			return variantId;
		}
	}
	return null; // If no variant with value 0 is found
};

const addAlreadyAddeddItems = async (targetSelector = false) => {
	console.log(targetSelector);
};

const ckAddToCart = (
	productId,
	variantId,
	memberPricingString = false,
	formattedMemberPrice = 0,
	firstImage,
	handle,
	title,
	productType,
	color = false
) => {
	if (productType == "single") {
		addToCartFunction(
			productId,
			variantId,
			memberPricingString,
			formattedMemberPrice,
			firstImage,
			handle,
			title
		);
	} else {
		$(
			`#collection-${window.openCollectionId} product-block[data-product-id="${productId}"] .file-icon`
		).click();
	}
};

const addToCartFunction = (
	productId,
	variantId,
	memberPricingString,
	formattedMemberPrice,
	firstImage,
	handle,
	title,
	selector = false
) => {
	const targetSelector = selector ? selector : productId;
	$(".bob" + targetSelector).text("adding...");

	const item = {
		id: variantId,
		quantity: 1,
	};

	if (memberPricingString) {
		item["properties"] = {
			_MemberDiscount: formattedMemberPrice,
		};
	}

	fetch(window.Shopify.routes.root + "cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ items: [item] }),
	})
		.then((response) => {
          console.log(response,"response")
			return response.json();
		})
		.then((data) => {
          console.log(data,"response")
			document.documentElement.dispatchEvent(
				new CustomEvent("on:cart:change", {
					bubbles: true,
					cancelable: false,
					detail: { openDrawer: false },
				})
			);

			const klaviyoData = {
				Name: title,
				ProductID: productId,
				Categories: ["Member Perk", "Underwear Expert"],
				ImageURL: firstImage,
				URL: "https://www.underwearexpert.com/products/" + handle,
				Brand: "Popstar Labs",
				Price: "$49.99",
				"Member Price": formattedMemberPrice,
				CompareAtPrice: "$0.00",
				"Added from subscription signup": "yes",
			};

			_learnq.push(["track", "Added to Cart", klaviyoData]);

			$(".bob" + targetSelector).addClass("added");
			$(".bob" + targetSelector)
				.next()
				.addClass("added");
			$(".bob" + targetSelector)
				.next()
				.attr("data-variant-id", variantId);
		});
};
